import { render } from "./LoadMoreButton.vue?vue&type=template&id=8c07d87c"
import script from "./LoadMoreButton.vue?vue&type=script&lang=js"
export * from "./LoadMoreButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__